import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Nav from "./Nav";

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await axios.get(
          `https://pressrequest.ghost.io/ghost/api/content/posts/`,
          {
            params: {
              key: "e9fe6a7eb33c6e005a1e6544da",
              slug,
              include: "authors,tags",
            },
          }
        );
       // Find the post with the matching slug
       const foundPost = response.data.posts.find((p) => p.slug === slug);
       setPost(foundPost);
      } catch (error) {
        console.error("Error fetching post:", error);
      }
    };

    fetchPost();
    console.log("Current slug:", slug);

  }, [slug]);

  if (!post) return <div>Loading...</div>;

  return (
    <div className="dashboard-container">
      <div className="px-6 max-w-7xl mx-auto">
        <Nav />
        <article className="bg-white shadow-lg rounded-lg overflow-hidden">
          {/* Featured Image */}
          {post.feature_image && (
            <img
              className="w-full h-96 object-cover"
              src={post.feature_image}
              alt={post.title}
            />
          )}

          <div className="p-12">
            {/* Title */}
            <h1 className="text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-6">
              {post.title}
            </h1>

            {/* Meta Info */}
            <div className="mt-4 flex items-center text-sm text-gray-600 mb-8">
              <span>By {post.primary_author.name}</span>
              <span className="mx-2">|</span>
              <span>{new Date(post.published_at).toLocaleDateString()}</span>
            </div>

            {/* Post Content */}
            <div
              className="text-lg text-gray-800 leading-relaxed space-y-8 prose lg:prose-xl"
              dangerouslySetInnerHTML={{
                __html: post.html.replace(
                  /<ul>/g,
                  '<ul class="list-disc ml-5 space-y-2">' // Apply Tailwind list styles
                ).replace(
                  /<a /g,
                  '<a class="text-red-600 underline "' // Apply red text and underline to links
                ),
              }}
            />
          </div>
        </article>
      </div>
    </div>
  );
};

export default BlogPost;
